<template>
    <div class="container">

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1>Pregled evidence dopusta</h1>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <Loading :active.sync="isLoading"
                         :can-cancel="false"
                         :is-full-page="false"></Loading>

                <!--                                {{vacationDaysReports}}-->
                <!--                mesec: {{$store.getters.getCurrentlySelectedMonth}}, leto: {{$store.getters.getCurrentlySelectedYear}}, uporabnik: {{$store.getters.getCurrentlySelectedUser}}-->

                <b-form-group
                        label="Izberi leto"
                        label-for="month"
                >

                    <div class="row">
                        <div class="col-md-3">
                            <v-select
                                    v-model="year"
                                    placeholder="leto"
                                    id="year"
                                    name="month"
                                    label="name"
                                    :reduce="item => item.id"
                                    :options="[
                                {id: 2018, name: '2018'},
                                {id: 2019, name: '2019'},
                                {id: 2020, name: '2020'},
                                {id: 2021, name: '2021'},
                                {id: 2022, name: '2022'},
                                {id: 2023, name: '2023'},
                                {id: 2024, name: '2024'},
                                {id: 2025, name: '2025'},
                                {id: 2026, name: '2026'},
                            ]"
                                    @input="$store.dispatch('setCurrentlySelectedYear', year); retrieveVacationDaysReport()"
                            >

                                <span slot="no-options">Ni zadetkov.</span>

                            </v-select>
                        </div>
                        <div class="col-md-3">
                            <v-select
                                    v-model="selectedUser"
                                    id="selectedUser"
                                    name="selectedUser"
                                    label="last_name"
                                    :options="users"
                                    :reduce="item => item.id"
                                    @input="$store.dispatch('setCurrentlySelectedUser', selectedUser); retrieveVacationDaysReport()"
                            >
                                <span slot="no-options">Ni zadetkov.</span>

                                <template slot="option" slot-scope="item">
                                    {{ getOptionLabel(item) }}
                                </template>

                                <template slot="selected-option" slot-scope="item">
                                    {{ getOptionLabel(item) }}
                                </template>


                            </v-select>
                        </div>
                    </div>
                </b-form-group>


                <vue-good-table
                        styleClass="vgt-table table table-hover table-striped"
                        :columns="columns"
                        :rows="vacationDaysReports"
                        :search-options="{
                                                        enabled: true,
                                                        skipDiacritics: true,
                                                        placeholder: 'vnesi iskalni pojem',
                                                    }"
                        :sort-options="{
                                                        enabled: true,
                                                      }">

                    <div slot="emptystate">
                        <div class="text-center text-muted font-weight-light"><i class="fa fa-exclamation-triangle"></i>
                            <em>Ni podatkov.</em></div>
                    </div>

                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'userId'">
                                {{getReadableUser(props.row.userId)}}
                        </span>

                        <span v-else-if="props.column.field == 'id'">

                            <router-link
                                    :to="{ name: 'AdminEditVacationDaysReport', params: {id: props.row.id, readonly: true }}"
                                    class="btn btn-info btn-sm text-white">
                                <i class="fa fa-eye"></i> Poglej</router-link>

                            <router-link
                                    :to="{ name: 'AdminEditVacationDaysReport', params: {id: props.row.id, readonly: false }}"
                                    class="btn btn-primary btn-sm text-white">
                                <i class="fa fa-edit"></i> Uredi</router-link>

                            <a class="btn btn-danger btn-sm text-white"
                               @click="deleteWorkHourReportConfirmation(props.row)"><i
                                    class="fa fa-trash"></i> Odstrani</a>
                        </span>

                        <span v-else>
                            {{props.row[props.column.field]}}
                        </span>


                    </template>
                </vue-good-table>

            </div>
        </div>

        <div class="row">
            <div class="col-md-12 mt-3 mb-5">

                <router-link :to="{ name: 'AdminEditVacationDaysReport' }" class="btn btn-success">
                    <i class="fa fa-plus"></i> Dodaj zapis v evidenco dopusta
                </router-link>

            </div>
        </div>

    </div>

</template>

<script>
  import firebase from 'firebase'
  import {db} from '../../main'
  import {VueGoodTable} from 'vue-good-table'
  import 'vue-good-table/dist/vue-good-table.css'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'

  export default {
    name: 'WorkHoursReport',
    components: {
      VueGoodTable,
      Loading,
      vSelect
    },
    data() {
      return {
        isLoading: false,
        year: this.$store.getters.getCurrentlySelectedYear,
        selectedUser: this.$store.getters.getCurrentlySelectedUser,
        users: this.$store.getters.getUsers,
        vacationDaysReports: [],
        monthAndYear: new Date(),
        columns: [
          {
            label: 'Oseba',
            field: 'userId',
            type: 'text',
            sortable: true,
            width: '150px'
          },
          {
            label: 'Skupaj dni dopusta',
            field: 'daysTotal',
            type: 'text',
            sortable: true,
          },
          {
            label: 'Koriščenih dni dopusta',
            field: 'daysUsed',
            type: 'text',
            sortable: true,
          },
          {
            label: 'Razpoložjivih dni dopusta',
            field: 'daysLeft',
            type: 'text',
            sortable: true,
          },
          {
            label: 'Bolniška odsotnost',
            field: 'sickLeave',
            type: 'text',
            sortable: true,
          },
          {
            label: 'Akcije',
            field: 'id',
            type: 'text',
            sortable: false,
            width: '350px'
          }
        ],
      }
    },
    mounted() {
      const _this = this

      if (_this.$store.getters.getUsers.length === 0) {
        _this.$store.dispatch('retrieveUsers').then(() => {
          _this.users = _this.$store.getters.getUsers
        })
      }

      _this.retrieveVacationDaysReport()

    },
    methods: {

      getOptionLabel(option) {
        //console.log(option);
        return this.getReadableUser(option.id)
      },

      retrieveVacationDaysReport() {
        const _this = this;
        _this.isLoading = true;

        console.log("retrieveVacationDaysReport");

        const selectedUserId = _this.$store.getters.getCurrentlySelectedUser;
        const selectedYear = _this.$store.getters.getCurrentlySelectedYear;

        console.log('Selected User ID', selectedUserId);
        console.log('Selected Year', selectedYear);

        // First get the vacation days reports (total days allocation)
        let vacationDaysReports = db.collection('vacationDaysReports');

        vacationDaysReports
          .where('year', '==', selectedYear)
          .where('userId', '==', selectedUserId)
          .get()
          .then(querySnapshot => {
            // Process vacation days reports
            const reports = _.filter(querySnapshot.docs.map(doc => doc.data()), {'userId': selectedUserId});

            // If we found reports, now we need to calculate used days from work hours reports
            if (reports.length > 0) {
              // For each report, calculate used days and sick leave days
              _this.calculateVacationUsage(reports, selectedUserId, selectedYear);
            } else {
              _this.vacationDaysReports = [];
              _this.isLoading = false;
            }
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.log('Error getting documents: ', error);
            _this.isLoading = false;
          });
      },

      calculateVacationUsage(reports, userId, year) {
        const _this = this;

        // Get the work hours reports for the entire year to calculate vacation usage
        const yearStartDate = _this.moment().set({
          date: 1,
          month: 0, // January
          year: year
        }).startOf('month').toDate();

        const yearEndDate = _this.moment().set({
          date: 31,
          month: 11, // December
          year: year
        }).endOf('month').toDate();

        db.collection('workHoursReports')
          .where('date', '>=', yearStartDate)
          .where('date', '<=', yearEndDate)
          .get()
          .then(querySnapshot => {
            // Filter for this user's reports
            const allYearlyReports = querySnapshot.docs
              .map(doc => doc.data())
              .filter(report => report.userId === userId);

            console.log('Found', allYearlyReports.length, 'reports for user in', year);

            // Calculate vacation days used
            let vacationDaysUsed = 0;
            let sickLeaveDaysUsed = 0;

            // Extract vacation reports
            const vacationReports = allYearlyReports.filter(report =>
              report.type === 'letni dopust'
            );

            // Calculate vacation days used
            _.each(vacationReports, function (val) {
              // 8 hours is a full workday
              if (val.duration === '8:0' || val.duration === '8:00') {
                vacationDaysUsed += 1;
              } else {
                // For partial days, convert to fractional days (e.g., 4 hours = 0.5 days)
                const durationParts = val.duration.split(':');
                const hours = parseInt(durationParts[0]);
                const minutes = parseInt(durationParts[1]);
                const totalHours = hours + (minutes / 60);
                vacationDaysUsed += (totalHours / 8); // Assuming 8-hour workday
              }
            });

            // Round to nearest 0.5
            vacationDaysUsed = Math.round(vacationDaysUsed * 2) / 2;

            // Extract sick leave reports
            const sickLeaveReports = allYearlyReports.filter(report =>
              report.type === 'bolniški dopust'
            );

            // Calculate sick leave days
            _.each(sickLeaveReports, function (val) {
              // 8 hours is a full workday
              if (val.duration === '8:0' || val.duration === '8:00') {
                sickLeaveDaysUsed += 1;
              } else {
                // For partial days, convert to fractional days (e.g., 4 hours = 0.5 days)
                const durationParts = val.duration.split(':');
                const hours = parseInt(durationParts[0]);
                const minutes = parseInt(durationParts[1]);
                const totalHours = hours + (minutes / 60);
                sickLeaveDaysUsed += (totalHours / 8); // Assuming 8-hour workday
              }
            });

            // Round to nearest 0.5
            sickLeaveDaysUsed = Math.round(sickLeaveDaysUsed * 2) / 2;

            // Update the reports with calculated values
            _.each(reports, function(report) {
              report.daysUsed = vacationDaysUsed;
              report.daysLeft = Math.max(0, report.daysTotal - vacationDaysUsed);
              report.sickLeave = sickLeaveDaysUsed;
            });

            // Update the UI
            _this.vacationDaysReports = reports;
            _this.isLoading = false;
          })
          .catch(function (error) {
            console.error('Error calculating vacation usage:', error);
            _this.vacationDaysReports = reports; // Show reports without usage calculations
            _this.isLoading = false;
          });
      },

      deleteWorkHourReportConfirmation(data) {
        const _this = this

        this.$swal({
          title: 'Opozorilo',
          text: 'Ali ste prepričani, da želite izbrisati evidenco za osebo ' + _this.getReadableUser(data.userId) + '? Po potrditvi izbire ne bo več mogoče preklicati.',
          dangerMode: true,
          buttons: {
            cancel: {
              text: 'Prekliči',
              value: null,
              visible: true,
              className: '',
              closeModal: true,
            },
            confirm: {
              text: 'Izbriši',
              value: true,
              visible: true,
              className: '',
              closeModal: true
            }
          },
        })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteWorkHourReport(data.id)

              case null:

                return

                break

              default:

            }
          })
      },
      deleteWorkHourReport(id) {
        const _this = this
        _this.isLoading = true
        db.collection('vacationDaysReports').doc(id).delete()
          .then(function () {
            _this.isLoading = false
            _this.retrieveVacationDaysReport();
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error deleting project: ', error)
          })
      },
      getReadableUser(userId) {
        const _this = this

        console.log(userId)

        let userObj = _.filter(_this.users, {'id': userId})[0]
        return userObj.first_name + ' ' + userObj.last_name

      },
      setMonthFilter() {
        const _this = this;
        _this.month = _this.month;
        console.log(_this.month);
      },
      setYearFilter() {
        console.log(_this.year);
      },

      getReadableUser(userId) {
        const _this = this

        let userObj = _.filter(_this.users, {'id': userId})[0]
        if (userObj) {
          return userObj.first_name + ' ' + userObj.last_name
        } else {
          return 'n/a'
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/admin/VacationDaysReport.vue